export default "__VITE_ASSET__2bed2684__"